import { useCallback, useEffect, useState } from "react";
import { getAppTemplates } from "../../network";
import {
  TGetAppTemplatesResponse,
} from "../../models";

export const useAppTemplates = (
  appId: string
): [TGetAppTemplatesResponse, boolean, Error | null, () => void] => {
  const [result, setResult] = useState<TGetAppTemplatesResponse>({
    items: [],
  });
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  const request = useCallback(async () => {
    if (appId) {
      setIsLoading(true);
      setError(null);

      try {
        const response = await getAppTemplates(appId);
        setResult(response);
      } catch (e) {
        if (e instanceof Error) {
          setError(e);
        } else {
          setError(new Error("Unknown error"));
        }
      }
      setIsLoading(false);
    }
  }, [appId]);

  useEffect(() => {
    request();
  }, [request]);

  return [result, isLoading, error, request];
};

